import { PISCINA_FOTOS } from "@/data/acomodacoes";
import { Gallery } from "@/components/Gallery";
import { Reveal, Eyebrow } from "@/components/Motion";

export const PiscinaSocial = () => (
  <section id="piscina" data-testid="piscina-section" className="grain relative bg-[#1a382b] py-24 text-[#f3efe4] sm:py-32">
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow light>Área social</Eyebrow>
          <h2 className="text-3xl font-bold tracking-[-0.035em] sm:text-6xl">Piscina Social</h2>
        </div>
        <p className="max-w-sm text-sm text-[#cfd8c9] md:text-base">Use as setas para navegar pelas fotos.</p>
      </Reveal>
      <Reveal>
        <Gallery fotos={PISCINA_FOTOS} alt="Piscina social da Quinta dos Pinhais" aspect="aspect-[4/3] md:aspect-[16/8]" thumbs testid="piscina-gallery" />
      </Reveal>
    </div>
  </section>
);
